import { render, staticRenderFns } from "./labelType.vue?vue&type=template&id=2eb4f96e&scoped=true&"
import script from "./labelType.vue?vue&type=script&lang=js&"
export * from "./labelType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4f96e",
  null
  
)

export default component.exports